//import api from '../../api'
import axios from 'axios';

// initial state
const state = {
    modalVisible: false,
    modalComponent: null
};

const mutations = {
    showModal(state, componentName) {
        state.modalVisible = true;
        state.modalComponent = componentName;
    },
    hideModal(state) {
        state.modalVisible = false;
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
